import React from 'react';
import { jsx, CSSObject } from '@emotion/core';
import { funcWithArgs } from '../../utils/types';

/**@jsx jsx */

export interface IFlex {
  stack?: boolean;
  ai?: 'center' | 'flex-start' | 'flex-end';
  jc?: 'center' | 'space-between' | 'flex-start' | 'flex-end';
  className?: string;
  id?: string;
  onClick?: funcWithArgs;
  styles?: CSSObject;
  tabIndex?: number;
}

const Flex: React.FC<IFlex> = ({
  tabIndex,
  children,
  ai = '',
  jc = '',
  stack = false,
  className,
  onClick,
  styles,
  id,
  ...rest
}) => {
  return (
    <div
      {...rest}
      tabIndex={tabIndex}
      onClick={onClick}
      id={id}
      className={className}
      css={{
        display: 'flex',
        flexDirection: stack ? 'column' : 'row',
        alignItems: ai,
        justifyContent: jc,
        cursor: 'pointer',
        ...styles,
      }}>
      {children}
    </div>
  );
};

export default Flex;
